(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/components/seo-article-widget/assets/javascripts/seo-article-widget.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/components/seo-article-widget/assets/javascripts/seo-article-widget.js');
"use strict";


const {
  loadArticle
} = svs.content.simple_article.contentLoader;
const logger = svs.core.log.getLogger('oddset_kambi:components:seo-article-widget');
class SeoArticleWidget extends HTMLElement {
  static get observedAttributes() {
    return ['args'];
  }
  get args() {
    return this.getAttribute('args');
  }
  connectedCallback() {
    const shadowRoot = this.attachShadow({
      mode: 'open'
    });
    if (!this.args) {
      return;
    }
    const {
      articleId
    } = JSON.parse(this.args);
    const options = {
      url: new svs.content.shared.ContentUrlBuilder("/content/2/id/".concat(articleId)).build()
    };
    const css = "\n      article {\n        padding: 6px 0;\n      }\n      a {\n        color: white;\n      }\n    ";
    loadArticle(options, (err, article) => {
      if (err) {
        logger.error('Something went wrong with loading CMS article ', err);
      } else if (!err && !article) {
        logger.warn('CMS article is not found with provided id');
      } else {
        shadowRoot.innerHTML = "\n        <style>\n          ".concat(css, "\n        </style>\n        <article>\n          ").concat(article.body, "\n        </article>");
      }
    });
  }
}
customElements.define('seo-article-widget', SeoArticleWidget);

 })(window);